const state = () => ({
    projectOptions:'', // 项目映射
    detail:''
})
const getters = {}
const mutations = {
    setProjectOptions(state,value){
        state.projectOptions = value
    },
    setDetail(state,value){
        state.detail = value
    }
}
export default {
    namespaced: true,
    state,
    getters,
    mutations
}
